export default __webpack_public_path__ + "static/media/appstore-googleplay.c760b87b.png";